/**
 * US ZIP helpers for the org-address forms.
 *
 * The pattern mirrors the server's ZIP rule on the partner org profile
 * (`PartnerOrgAddressInput` in server/app/models/api/partner.py) and on the
 * GPO pharmacy create (`GpoPharmacyCreateRequest` in
 * server/app/models/api/gpo.py): a 5-digit ZIP or ZIP+4.
 */
const ZIP_RE = /^\d{5}(-\d{4})?$/;

/**
 * Validates a required ZIP: an error message when invalid, or `null` for a
 * 5-digit ZIP or ZIP+4. A blank value fails with the same message.
 */
export function validateZip(zip: string): string | null {
  if (!ZIP_RE.test(zip.trim())) {
    return "Enter a 5-digit ZIP code (e.g. 90210) or ZIP+4 (90210-1234).";
  }
  return null;
}

/**
 * Formats a 9-digit unhyphenated ZIP, the shape NPPES often returns, as ZIP+4.
 * A 5-digit or already-hyphenated value passes through, and so does anything
 * else, since a prefill mirrors the registry.
 */
export function normalizeZip(zip: string): string {
  return /^\d{9}$/.test(zip) ? `${zip.slice(0, 5)}-${zip.slice(5)}` : zip;
}
